 <button (click)="click.next();$event.stopPropagation()"
    class="flex flex-row items-center flex-auto w-full gap-4 py-1 font-medium opacity-80 hover:opacity-100"  [disabled]="disabled" [class.disabled]="disabled">
    <mat-icon [class.icon-size-5]="leftIconSize==='small'" [style.color]="leftIconColor" [svgIcon]="leftIcon" *ngIf="leftIcon"> </mat-icon>
    <span class="flex flex-auto"> {{label}}</span>
    <mat-icon  [class.icon-size-5]="rightIconSize==='small'" [style.color]="rightIconColor" [svgIcon]="rightIcon" *ngIf="rightIcon">
    </mat-icon>
</button>
